'use client';

import { ActionButton } from '@/components/ui/ActionButton';
import { Text } from '@/components/ui/Text';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface HelpTextProps {
  darkBackground?: boolean;
}

/**
 * HelpText component displayed below CTAs on each step.
 * Contains link to schedule a call with membership team.
 */
export function HelpText({ darkBackground = false }: HelpTextProps) {
  const textColor = darkBackground ? 'text-white' : 'text-[#292722]';

  return (
    <p
      className={`text-center font-sans text-[18px] leading-[130%] font-normal ${textColor}`}
    >
      Have questions?{' '}
      <Link href='/contact-us' className='underline'>
        Set up a call with our Membership Team
      </Link>{' '}
      to learn more.
    </p>
  );
}

export function HelpBlock() {
  const router = useRouter();

  return (
    <div className='flex max-w-[1388px] flex-col gap-[40px] py-[70px] text-center lg:py-[120px]'>
      <Text variant='h1-serif' color='dark' className='text-center'>
        Have questions? Schedule a call with our Membership Team.
      </Text>
      <div className='px-[9px]'>
        <ActionButton
          label='Schedule A Call'
          variant='cream'
          className='w-full md:w-auto'
          onClick={() => router.push('/contact-us')}
        />
      </div>
    </div>
  );
}
